import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { X, Loader } from "lucide-react";
import Step1BusinessInfo from "./Step1BusinessInfo";
import Step2ContactDetails from "./Step2ContactDetails";
import Step3BusinessAddress from "./Step3BusinessAddress";
import Step4MediaUpload from "./Step4MediaUpload";
import Step5BusinessSummary from "./Step5BusinessSummary";
import BusinessSuccess from "./BusinessSucess";

import {
  addBusiness,
  getBusinessTypesAndServices,
} from "../../../services/business";
import { handlePostRequest } from "../../../hooks/api";
import { errorToast } from "../../../utils/toasters";
import { isAuthenticated } from "../../../utils/helpers";
export default function AddBusinessModal({ onClose }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [isProcessing, setIsProcessing] = useState(false);

  const [businessType, setBusinessType] = useState([]);
  const [businessInfo, setBusinessInfo] = useState([]);
  const [businessServices, setBusinessServices] = useState([]);

  const [selectedBusinessServices, setSelectedBusinessServices] = useState([]);
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);
  const navigate = useNavigate();

  const [locationPlaceId, setLocationPlaceId] = useState("");
  let prevBusiness = "";

  useEffect(() => {
    if (selectedBusinessType === "") {
      return;
    }

    const business = businessInfo.find(
      (bi) => bi.name === selectedBusinessType.value
    );
    if (!business) {
      return;
    }
    if (prevBusiness == selectedBusinessType.value) {
      return;
    }
    setSelectedBusinessServices([]);
    prevBusiness = selectedBusinessType.value;
    const services = business.services.map((sv) => {
      return { label: sv.name, value: sv.name };
    });
    setBusinessServices(services);
  }, [selectedBusinessType]);

  useEffect(() => {
    async function needsFetcher() {
      try {
        const response = await getBusinessTypesAndServices();
        const businessType = response.data.map((d) => {
          return { label: d.name, value: d.name };
        });

        setBusinessType(businessType);
        setBusinessInfo(response.data);
      } catch (error) {
        console.error("Error while getting event needs: ", error);
      }
    }
    needsFetcher();
  }, []);

  const [formData, setFormData] = useState({
    businessname: "",
    businessdescription: "",
    contactperson: "",
    contactemail: "",
    contactphone: "",
    contactotherphone: "",
    businessaddress1: "",
    businessaddress2: "",
    businessaddress3: "",
    businesscity: "",
    businessstate: "",
    businesslocationmap: null,
    businesscertificate: null,
    businessimageurl: null,
    businessvideourl: null,
    completed: false,
  });

  // Handle escape key to close modal
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);

    // Prevent scrolling on body when modal is open
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  const handleNext = () => {
    if (currentStep === 5) {
      // Show success page
      setCurrentStep(6);
    } else {
      setCurrentStep((prev) => Math.min(prev + 1, 5));
    }

    // Scroll to top of modal when changing steps
    const modalContent = document.getElementById("modal-content");
    if (modalContent) {
      modalContent.scrollTop = 0;
    }
  };

  const handleBack = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));

    // Scroll to top of modal when changing steps
    const modalContent = document.getElementById("modal-content");
    if (modalContent) {
      modalContent.scrollTop = 0;
    }
  };

  const handleDone = async () => {
    setIsProcessing(true);

    try {
      if (!isAuthenticated()) {
        navigate("/signin");
        return;
      }
      let businessS3ImageUrl = "";
      if (formData.businessimageurl) {
        let imageData = new FormData();
        imageData.append("image", formData.businessimageurl);
        businessS3ImageUrl = await handlePostRequest(
          "/auth/upload-image-to-s3",
          imageData,
          {},
          true
        );
      }

      let businessS3CertificateUrl = "";
      if (formData.businesscertificate) {
        let imageData = new FormData();
        imageData.append("image", formData.businesscertificate);
        businessS3CertificateUrl = await handlePostRequest(
          "/auth/upload-image-to-s3",
          imageData,
          {},
          true
        );
      }

      let businessS3VideoUrl = "";
      if (formData.businessvideourl) {
        let imageData = new FormData();
        imageData.append("image", formData.businessvideourl);
        businessS3VideoUrl = await handlePostRequest(
          "/auth/upload-image-to-s3",
          imageData,
          {},
          true
        );
      }

      let payload = {
        businessname: formData.businessname,
        businessdescription: formData.businessdescription,
        contactperson: formData.contactperson,
        contactemail: formData.contactemail,
        contactphone: formData.contactphone,
        contactotherphone: formData.contactotherphone,
        businessaddress1: formData.businessaddress1,
        businessaddress2: formData.businessaddress2,
        businessaddress3: formData.businessaddress3,
        businesscity: formData.businesscity,
        businessstate: formData.businessstate,
        businesslocationmap: formData.businesslocationmap,
        businesscertificate: businessS3CertificateUrl
          ? businessS3CertificateUrl.data.length > 0
            ? businessS3CertificateUrl.data[0]
            : ""
          : "",
        businessimageurl: businessS3ImageUrl
          ? businessS3ImageUrl.data.length > 0
            ? businessS3ImageUrl.data[0]
            : ""
          : "",
        businessvideourl: businessS3VideoUrl
          ? businessS3VideoUrl.data.length > 0
            ? businessS3VideoUrl.data[0]
            : ""
          : "",
      };

      payload["business_type"] = selectedBusinessType.value;

      payload["google_place_id"] = locationPlaceId;
      console.log("businessser", selectedBusinessServices);
      if (selectedBusinessServices && selectedBusinessServices.length > 0) {
        payload["services"] = selectedBusinessServices
          .map((sb) => sb.value)
          .join(",");
      }
      payload["geohash"] = localStorage.getItem("geohash") || "9v6m";
      await addBusiness(payload);
      setFormData((prev) => ({ ...prev, completed: true }));
      setCurrentStep(6);
    } catch (error) {
      errorToast(
        "Error while submitting your business. Please try again later."
      );
      console.error("Error submitting business:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const updateFormData = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };

  const goToStep = (step) => {
    setCurrentStep(step);
    // Scroll to top of modal when changing steps
    const modalContent = document.getElementById("modal-content");
    if (modalContent) {
      modalContent.scrollTop = 0;
    }
  };

  // Close modal on backdrop click
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const renderContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1BusinessInfo
            formData={formData}
            businessServices={businessServices}
            businessType={businessType}
            selectedBusinessType={selectedBusinessType}
            selectedBusinessServices={selectedBusinessServices}
            setSelectedBusinessType={setSelectedBusinessType}
            setSelectedBusinessServices={setSelectedBusinessServices}
            updateFormData={updateFormData}
            onNext={handleNext}
          />
        );
      case 2:
        return (
          <Step2ContactDetails
            formData={formData}
            updateFormData={updateFormData}
            onBack={handleBack}
            onNext={handleNext}
          />
        );
      case 3:
        return (
          <Step3BusinessAddress
            formData={formData}
            updateFormData={updateFormData}
            setLocationPlaceId={setLocationPlaceId}
            onBack={handleBack}
            onNext={handleNext}
          />
        );
      case 4:
        return (
          <Step4MediaUpload
            formData={formData}
            updateFormData={updateFormData}
            onBack={handleBack}
            onNext={handleNext}
          />
        );
      case 5:
        return (
          <Step5BusinessSummary
            formData={formData}
            onBack={handleBack}
            onDone={handleDone}
            goToStep={goToStep}
          />
        );
      case 6:
        return <BusinessSuccess formData={formData} onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 md:p-6"
      onClick={handleBackdropClick}
    >
      {isProcessing && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 flex flex-col items-center">
            <Loader className="animate-spin mb-4" width={48} height={48} />
            <p className="text-gray-600">Submitting your business...</p>
          </div>
        </div>
      )}

      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md mx-auto overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header - Only show for non-success views */}
        {currentStep !== 6 && (
          <div className="flex items-center justify-between p-4 border-b">
            <h1 className="text-xl font-bold">Add Business</h1>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              aria-label="Close"
            >
              <X size={20} />
            </button>
          </div>
        )}

        {/* Content */}
        <div
          id="modal-content"
          className="overflow-y-auto max-h-[calc(100vh-150px)] p-4"
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
}
